module.exports = {
	extends: [
		'/',
		'base',
		'tooltip',
		'tooltip'
	],

	model: {
		titleKey: 'form.fields.selectEmployeeJobs.showOnRegistrationMarkers.title',
		messageKey: 'form.fields.selectEmployeeJobs.showOnRegistrationMarkers.message'
	},
};
